<template>
  <v-slide-y-transition mode="out-in">
    <v-container>
      <v-layout justify-center>
        <v-flex xs12>
          <v-toolbar
            dark
            color="grey lighten-1">
            <v-icon class="fas fa-envelope"></v-icon>
            <v-toolbar-title>Contact ITG</v-toolbar-title>
          </v-toolbar>
          <v-card>
            <v-container fluid>
              <v-layout row wrap>
                <v-flex>
                  <v-alert
                    :value="warning"
                    type="warning">
                    The contact attempt failed: {{ warningMessage }}
                  </v-alert>
                  <v-alert
                    :value="success"
                    type="success">
                    The contact was sent. We will respond to your inquiry soon.
                  </v-alert>
                  <p>To contact ITG please fill out the form below. Be sure to give us a way to contact you so that we can reply.</p>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                      v-model="name"
                      :rules="nameRules"
                      label="Name"
                      color="blue-grey"
                      required></v-text-field>
                    <v-text-field
                      v-model="company"
                      label="Company"
                      color="blue-grey"></v-text-field>
                    <v-text-field
                      v-model="phone"
                      :rules="phoneRules"
                      label="Phone"
                      color="blue-grey"
                      mask="phone"
                      required></v-text-field>
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      label="Email"
                      color="blue-grey"
                      required></v-text-field>
                    <v-select
                      :items="subjects"
                      v-model="subject"
                      :rules="subjectRules"
                      label="Select"
                      color="blue-grey"
                      max-height="400"
                      hint="What's this about?"
                      persistent-hint
                      required></v-select>
                    <v-select
                      :items="referrents"
                      v-model="referrer"
                      label="Select"
                      color="blue-grey"
                      max-height="400"
                      hint="How did you hear about us?"
                      persistent-hint></v-select>
                    <v-textarea
                      label="Your comments"
                      v-model="comments"
                      hint="Comments"></v-textarea>
                    <vue-recaptcha
                      ref="recaptcha"
                      sitekey="6Lc-p2sUAAAAAKdXHMUFvrRR6_NJOvKzs18jp5gW"
                      @verify="onVerify"
                      @expired="onExpired"></vue-recaptcha>
                    <v-flex class="mt-5">
                      <v-btn
                        :disabled="!valid"
                        @click="submit">
                        submit
                      </v-btn>
                      <v-btn @click="clear">clear</v-btn>
                    </v-flex>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-slide-y-transition>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha'
  import axios from 'axios'
  import qs from 'qs'

  export default {
    name: 'contact',
    components: {
      VueRecaptcha
    },
    data () {
      return {
        valid: false,
        recaptchaKey: '',
        warning: false,
        warningMessage: '',
        name: '',
        nameRules: [
          v => !!v || 'Name is required'
        ],
        company: '',
        phone: '',
        phoneRules: [
          v => !!v || 'Phone number is required',
          v => /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(v) || 'Please enter a valid phone number'
        ],
        email: '',
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
        subject: '',
        subjectRules: [
          v => !!v || 'Subject is required'
        ],
        referrer: '',
        comments: '',
        subjects: [
          'Training Courses',
          'Evaluation',
          'Coaching',
          'Consulting',
          'More Information',
          'This Web Site'
        ],
        referrents: [
          'Online Advertisement',
          'Search Engine',
          'Print Advertisement',
          'Yellow Pages',
          'Personal Reference'
        ],
        success: false
      }
    },
    methods: {
      onVerify: function (response) {
        if (!response.length) {
          this.warning = true
          this.warningMessage = 'Captcha not verified. Please try again.'
        }
        this.recaptchaKey = response
      },
      onExpired: function () {
        this.resetRecaptcha()
      },
      resetRecaptcha () {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
      submit () {
        if (this.$refs.form.validate()) {
          // Native form submission is not yet supported
          const values = {
            name: this.name,
            company: this.company,
            phone: this.phone,
            email: this.email,
            subject: this.subject,
            referrer: this.referrer,
            comments: this.comments
          }

          axios.post('/send.php', qs.stringify(values)).then(response => {
            if (response.status) {
              this.success = true
              setTimeout(() => {
                this.success = false
              }, 3000)
            } else {
              this.warning = true
              this.warningMessage = response.warningMessage
            }
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Contact.vue